module.exports = __webpack_public_path__ + "media/bing-cold.e34b96e9.mp3";